import React from 'react'

import Section from '../Section'

import urlIcon from 'assets/images/contacts/Editor/editor-link-20.svg'
import { useTranslation } from 'react-i18next'

interface URLsProps {
  editData: any
  onFieldChange: (propName: string, index: number, value: any) => void
  onLabelChange: (propName: string, index: number, label: string) => void
  onAddItem: (propName: string, label: string) => void
  onDelete: (propName: string, index: number) => void
}

const URLs = ({ editData, onFieldChange, onLabelChange, onAddItem, onDelete }: URLsProps) => {
  const { t } = useTranslation()
  return (
    <Section
      editData={editData}
      propName="urls"
      labelList={[
        { key: 'website', label: t('contact.property.website') },
        { key: 'linkedin', label: t('contact.property.linkedin') },
        { key: 'facebook', label: t('contact.property.facebook') },
        { key: 'github', label: t('contact.property.github') },
        { key: 'skype', label: t('contact.property.skype') },
        { key: 'twitter', label: t('contact.property.twitter') },
        { key: 'whatsapp', label: t('contact.property.whatsapp') },
        { key: 'instagram', label: t('contact.property.instagram') },
        { key: 'other', label: t('contact.property.other') },
        { key: '', label: t('contact.property.none') },
        { key: 'custom', label: t('contact.property.custom') },
      ]}
      icon={urlIcon}
      addButtonLabel={t('contact.menu.addLink')}
      onFieldChange={onFieldChange}
      onLabelChange={onLabelChange}
      onAddItem={onAddItem}
      onDelete={onDelete}
      canDelete={(_) => true}
    />
  )
}
export default URLs
